import React from 'react';
import { motion } from 'framer-motion';
import TeamMembersManagerV2 from '../../team/TeamMembersManagerV2';

const TeamMembersTab = ({ displayUser, isReadOnly, showAddModal, onExternalAddModalClose }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="space-y-6"
    >
      <TeamMembersManagerV2
        userId={displayUser?.uid || displayUser?.id}
        isReadOnly={isReadOnly}
        externalAddModal={showAddModal}
        onExternalAddModalClose={onExternalAddModalClose}
      />
    </motion.div>
  );
};

export default TeamMembersTab;
